import React, { createContext, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { initialContext } from "./context/context";
import App from './App';

const path = (/#!(\/.*)$/.exec(window.location.href) || [])[1]

export const MobileContext = createContext();

export const MobileContextProvider = props => {
    const initialContextState = sessionStorage.getItem('MobileContext') ? JSON.parse(sessionStorage.getItem('MobileContext')) : initialContext;
    const [state, setState] = useState(initialContextState);
    return (
        <MobileContext.Provider value={[state, setState]}>
            {props.children}
        </MobileContext.Provider>
    );
}

const root = createRoot(document.getElementById('root'));

root.render(
  <MobileContextProvider>
    <App />
  </MobileContextProvider>
);
